import { DateMode } from "../types";

export const DateModeToFormatMap: Record<DateMode, string> = {
  "mm/dd/yyyy": "MM/dd/yyyy",
  "dd/mm/yyyy": "dd/MM/yyyy",
  "yyyy/mm/dd": "yyyy/MM/dd",
};

export const DateModeToPlaceholderMap: Record<DateMode, string> = {
  "dd/mm/yyyy": "__/__/____",
  "mm/dd/yyyy": "__/__/____",
  "yyyy/mm/dd": "____/__/__",
};
